import { render, staticRenderFns } from "./SidesPage.vue?vue&type=template&id=39f728b8&"
import script from "./SidesPage.vue?vue&type=script&lang=js&"
export * from "./SidesPage.vue?vue&type=script&lang=js&"
import style0 from "./SidesPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports